import { PaginationProps } from '@mui/material'
import { ProductListPaginationFragment } from '../../ProductListPagination/ProductListPagination.gql'
import { ProductListParams } from '@graphcommerce/magento-product'
import { ProductListLink } from './ProductListLink'
import { Pagination } from './Pagination'

export type ProductPaginationProps = ProductListPaginationFragment &
  Omit<PaginationProps, 'count' | 'defaultPage' | 'page' | 'renderItem'> & {
    params: ProductListParams
  }

export default function ProductListPagination({
  page_info,
  params,
  ...paginationProps
}: ProductPaginationProps) {
  if (!page_info || !page_info.total_pages || !page_info.current_page) return null

  return (
    <Pagination
      count={page_info?.total_pages}
      page={page_info?.current_page ?? 1}
      classes={{ root: '!rtl' }}
      renderLink={(_, icon, btnProps) => (
        <ProductListLink {...btnProps} {...params} currentPage={btnProps.page} color='inherit'>
          {icon}
        </ProductListLink>
      )}
      {...paginationProps}
    />
  )
}
